<script lang="ts">
  import TabCatsDesktop from '$lib/components/menu/TabCatsDesktop.svelte';
	import UniversesMenu from '$lib/components/universes/UniversesMenu.svelte'
	import UniversesBanner from '$lib/components/universes/UniversesBanner.svelte'
	import { getUniverseInfo } from '$lib/js/helpers'
  import { page } from '$app/stores';
  import { storeHeroMenu } from '$lib/js/stores'
  import type { Category } from "$lib/js/elasticsearch/types";

  export let firstLevel: Category[]
  export let secondLevel: Category[]
  export let thirdLevel: Category[]

  // Menu header
  $: universe_info = getUniverseInfo(
    $page.data?.universes_menu?.universes,
    $page.data?.category?.url_path?.split("/")[1]
  )
</script>



<nav class="hero-menu">
  <div class="container">
    <div tabindex="0" role="menu" class="hero-menu__wrapper" on:mouseleave={() => {$storeHeroMenu = ''}}>
      {#if $storeHeroMenu === "categories"}
        <TabCatsDesktop {firstLevel} {secondLevel} {thirdLevel} />
      {:else if $storeHeroMenu === "shops"}
        {#if universe_info}
          <UniversesBanner type="bixoto"/>
        {:else}
          <UniversesMenu {secondLevel} {thirdLevel} />
        {/if}
      {/if}
    </div>
  </div>
</nav>


<style lang="scss">
  .hero-menu {
    position: fixed;
    right: 0;
    left: 0;
    top: 100px;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);

    &__wrapper {
      border-top: 5px solid var(--grey);
      padding: 0 20px 20px;
      background: white;
    }

    &__header {
      display: flex;

      .bixoto {
        display: flex;
        margin-top: 10px;
        margin-right: 20px;
        width: 90px;
      }

      button {
        padding: 10px 20px;
        background: var(--grey);

        &.selected {
          background: white;
        }
      }
    }
  }
</style>
